import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiBookOpen, FiEdit3, FiInfo, FiList, FiLogIn, FiLogOut, FiMessageSquare, FiPlus, FiSettings, FiShoppingBag, FiTool, FiUsers } from 'react-icons/fi';
import './Sidebar.css';
import { SCENARIOS_PATH } from './scenes';

// The app-wide navigation sidebar: primary actions at the top, and a
// Settings/Logout group pinned to the bottom. Rendered on every screen except
// the Chat conversation view (see AppLayout in App.js).
//
// `onLogout` is optional and doubles as the session signal: only the public
// About page renders the sidebar without a handler (see AppLayout in App.js),
// and in that case the sidebar collapses to the logo and the About link —
// every other destination sits behind requireAuth.
function Sidebar({ onLogout }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const authenticated = Boolean(onLogout);

  return (
    <nav className="chat-list-sidebar">
      <img
        src={`${process.env.PUBLIC_URL}/logo512.png`}
        alt="AutoLang logo"
        className="sidebar-logo"
      />
      {authenticated && (
        <>
          <button onClick={() => navigate('/chats')} className="sidebar-button">
            <FiList className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.chatsList')}
          </button>
          <button onClick={() => navigate('/chats/new')} className="sidebar-button">
            <FiPlus className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.newChat')}
          </button>
          <button onClick={() => navigate('/personas')} className="sidebar-button">
            <FiUsers className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.myPersonas')}
          </button>
          <button onClick={() => navigate('/personas/build')} className="sidebar-button">
            <FiTool className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.buildPersona')}
          </button>
          <button onClick={() => navigate('/personas/new')} className="sidebar-button">
            <FiEdit3 className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.writePersona')}
          </button>
          {/* Two errands, not one screen with a mode: Play offers what there is to play,
              Scenes holds the record of every run already played. */}
          <button onClick={() => navigate(SCENARIOS_PATH)} className="sidebar-button">
            <FiShoppingBag className="sidebar-button-icon" aria-hidden="true" />{' '}
            {t('sidebar.play')}
          </button>
          <button onClick={() => navigate('/scenes')} className="sidebar-button">
            <FiBookOpen className="sidebar-button-icon" aria-hidden="true" />{' '}
            {t('sidebar.scenes')}
          </button>
        </>
      )}
      <button onClick={() => navigate('/about')} className="sidebar-button">
        <FiInfo className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.about')}
      </button>
      {!authenticated && (
        <button onClick={() => navigate('/login')} className="sidebar-button">
          <FiLogIn className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.login')}
        </button>
      )}
      {authenticated && (
        <div className="sidebar-settings">
          <button onClick={() => navigate('/feedbacks')} className="sidebar-button">
            <FiMessageSquare className="sidebar-button-icon" aria-hidden="true" />{' '}
            {t('sidebar.myFeedback')}
          </button>
          <button onClick={() => navigate('/profile')} className="sidebar-button">
            <FiSettings className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.profile')}
          </button>
        </div>
      )}
      {onLogout && (
        <button onClick={onLogout} className="sidebar-button sidebar-logout-button">
          <FiLogOut className="sidebar-button-icon" aria-hidden="true" /> {t('sidebar.logout')}
        </button>
      )}
    </nav>
  );
}

export default Sidebar;
